// extracted by mini-css-extract-plugin
export default {"container":"main_container__3inZn","inner":"main_inner__1BBF1"};